/*
    Q. What are all the features?
    A. look at UIConfiguration's fields in the backend django code!
 */

import { API_ROOT } from '../config';

const utilsMixin = {
  methods: {
    apiRoot() {
      return API_ROOT;
    },
    useFeature(featureName) {
      if (this.$store.state.account.user == null) {
        return false;
      }
      // console.log(this.$store.state.account.user.profile.ui);
      const { ui } = this.$store.state.account.user.profile;
      if (ui != null && this.$store.state.account.user.profile.ui[featureName] === true) return true;
      return false;
    },
    usePermission(featureName) {
      if (this.$store.state.account.user == null) {
        return false;
      }
      const featurePerm = this.$store.state.account.user.profile.features[featureName];
      if (typeof featurePerm !== 'undefined') return true;
      return false;
    },
    getFeature(featureName) {
      if (this.$store.state.account.user == null) {
        return null;
      }
      const { ui } = this.$store.state.account.user.profile;
      if (ui != null && this.$store.state.account.user.profile.ui[featureName]) {
        return this.$store.state.account.user.profile.ui[featureName];
      }
      return null;
    },
    formatLikeLocationLabel(obj) { // originally via 9bba8328f
      if (obj.likeLocationLabel) {
        return obj.likeLocationLabel;
      } else if (obj.appointment || obj.is_video_appointment_like) {
        return 'Virtual appointment';
      }
      return 'Album'; // XXX default text better retrieved from API?
    },

    getCurrencyLocale() {
      const locale = this.$store.state.institutions.currencyLocale || 'en-US'; // updateCurrencyLocale
      return locale;
    },
    formatReportValue(entry) {
      if (entry.type === 'number') {
        // return this.formatPrice(entry.value);   // original/old
        return this.$n(entry.value, 'currency', this.getCurrencyLocale()); // new 12/22/21
      }
      return this.formatPercent(entry.value);
    },
    formatPrice(num) {
      if (num === null || num === undefined) {
        return '--';
      }
      return this.$options.filters.formatPrice(num); // src/_utilities/textMixins.js:63
    },
    formatPercent(num) {
      if (num === null || num === undefined) {
        return '--%';
      }
      return `${this.$options.filters.formatFloat(num)}%`;
    },

    getProductName({
      title,
      product,
      brand,
      isActivityLike,
    }) {
      /** Method that replaces the brand name for the product description in various tooltips when
       *  the theme has product_display_brand=false. */
      const showBrand = this.$store.getters['account/theme'].product_display_brand;
      const brandName = brand?.name || product?.brand?.name;
      const itemDescription = title || product?.title;
      // eslint-disable-next-line no-prototype-builtins
      if (isActivityLike && !brand?.hasOwnProperty('pk')) {
        // This is for Album likes (which have "fake brands" to get the name) shown in the Views tab in the Dashboard Activity
        return brandName;
      }
      return (showBrand && brandName) ? brandName : (itemDescription || '');
    },

  },
};

export default utilsMixin;
